import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import AlertsNotificationBadge from "@/components/AlertsNotificationBadge";
import TheSidebarMenu from "@/components/TheSidebarMenu";
import TopAccount from "@/components/TopAccount";
import AppIcon from "@/components/AppIcon";
import AppPopover from "@/components/AppPopover";
import { EVENTS } from "@/utils/constants";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
export default {
  name: "TheSidebar",
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isHovering: {
      type: Boolean,
      default: false
    },
    handleCollapseBtnClickedToClose: {
      type: Function,
      default: () => {}
    },
    isProfileSettingsShown: {
      type: Boolean,
      default: false
    },
    showTopAccountListView: {
      type: Boolean,
      default: false
    }
  },
  emits: ["handleCollapse", "handleMouseEnter", "handleMouseLeave", "handleProfileSettingsClick", "closeProfileSettingsPanel", "handleTopAccountBtnClicked"],
  data() {
    return {
      openItemText: null,
      collapseBtnClickedToClose: true,
      dataLoading: true,
      settingsItems: [{
        text: "Notifications",
        id: "notification",
        url: "/alerts-page",
        icon: "notification-new-ui",
        color: "#FFFFFF",
        featureName: "alertsfeature"
      }, {
        text: "Help",
        id: "help",
        action: "openIntercom",
        icon: "help-new-ui",
        color: "#FFFFFF",
        featureName: "helpmenufeature",
        event: "intercomModuleOpened"
      }],
      settingsBtn: [{
        name: "profileSetting",
        url: "/profile",
        text: "Profile Settings",
        icon: "settings-icon-v2"
      }, {
        name: "logout",
        text: "Log out",
        icon: "logout-icon"
      }]
    };
  },
  components: {
    TheSidebarMenu,
    TopAccount,
    AppIcon,
    AppPopover,
    AlertsNotificationBadge,
    WrapWithPopover
  },
  computed: {
    ...mapState({
      me: state => state.auth.me,
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyUser: state => state.auth.isOmnyUser,
      isClientAdmin: state => state.auth.isClientAdmin,
      isClientUser: state => state.auth.isClientUser,
      token: state => state.auth.token,
      accounts_list: state => state.account.list,
      alerts: state => state.alerts.list,
      urgencyCount: state => state.alerts.urgencyCount,
      current_workspace: state => state.workspace.current_workspace
    }),
    ...mapGetters(["userRoleGet", "workspaceCurrent"]),
    userName() {
      return this.me.first_name + " " + this.me.last_name;
    },
    showSmallLogo() {
      return this.isCollapsed && !this.isHovering;
    }
  },
  created() {
    window.$bus.on(EVENTS.CLOSE_SIDEBAR, this.closeSidebar);
  },
  async mounted() {
    //this.openItemText = this.$route.path.indexOf(item.url) == 0;
    var is_authenticated = await this.authStatus();
    if (is_authenticated) {
      const accountIds = this.accounts_list.map(item => item.account_id);
      if (accountIds.length) {
        await this.alertsUrgentCount({
          seller_list: accountIds
        });
      }
    }
  },
  methods: {
    ...mapMutations(["authTokenSet", "urgencyCountSet"]),
    ...mapActions(["authLogout", "authStatus", "alertsList", "workspaceList", "alertsUrgentCount"]),
    async onClick(item) {
      if (item.name == "logout") {
        this.loading = true;
        await this.authLogout();
        this.loading = false;
        return;
      }
      if (item.action == "openIntercom") {
        if (window.Intercom) {
          window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
            event_name: item.event,
            properties: {}
          });
          window.Intercom("show");
          return;
        }
      }
      this.$emit("closeProfileSettingsPanel");
      this.$router.push(item.url);
    },
    handleCollapseClick() {
      if (this.isProfileSettingsShown || this.showTopAccountListView) {
        return;
      }
      // Check if the sidebar is collapsed
      if (!this.isCollapsed) {
        this.collapseBtnClickedToClose = true;
      } else {
        this.collapseBtnClickedToClose = false;
      }
      this.$emit("handleCollapse", !this.isCollapsed);
    },
    handleMouseEnter(event) {
      const sidebar = this.$refs.sidebar;
      const collapseBtn = this.$refs.collapseBtn;

      // If the sidebar is collapsed and the collapse button is clicked, then open the sidebar
      // if the mouse is over the collapse button, then do nothing
      // if the mouse is over the sidebar, then close the sidebar
      if (this.collapseBtnClickedToClose) {
        if (event.target === collapseBtn || collapseBtn.contains(event.target) || sidebar.contains(event.target)) {
          return;
        } else {
          this.$emit("handleMouseEnter", true);
        }
      }
    },
    handleMouseLeave(event) {
      if (this.isProfileSettingsShown || this.showTopAccountListView) {
        return;
      }
      const sidebar = this.$refs.sidebar;
      const collapseBtn = this.$refs.collapseBtn;

      // Only close the sidebar if it was collapsed and the collapse button was clicked
      if (this.collapseBtnClickedToClose) {
        if (!sidebar.contains(event.relatedTarget) && !collapseBtn.contains(event.relatedTarget)) {
          this.$emit("handleMouseLeave", false);
        }
      }
    },
    handleListViewToggled() {
      this.$emit("handleTopAccountBtnClicked");
    },
    async onMenuClick(item) {
      this.openItemText = this.openItemText === item.text ? null : item.text;
    },
    closeSidebar() {
      this.handleCollapseClick();
    },
    openSidebar() {
      this.handleCollapseClick();
    },
    getFeatureName(item) {
      return item.featureName;
    }
  }
};